import type { ReactNode } from 'react';

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  hero?: boolean;
}

export const PageHeader = ({ title, subtitle, actions, hero = false }: Props) => (
  <header
    className={`flex items-end justify-between gap-6 px-10 ${
      hero ? 'pt-10 pb-7' : 'pt-7 pb-5'
    }`}
  >
    <div className="min-w-0">
      {hero ? (
        <h1 className="m-0 font-serif font-normal text-[44px] leading-[1.05] tracking-tightest text-ink">
          {title}
        </h1>
      ) : (
        <h1 className="m-0 font-semibold text-[22px] leading-snug tracking-tight text-ink">
          {title}
        </h1>
      )}
      {subtitle && (
        <p className="mt-2 text-[13.5px] leading-relaxed text-ink-muted">{subtitle}</p>
      )}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
  </header>
);
